import { useRef, useState } from "react";

/**
 * A draft that follows `stored` while the field is untouched, and keeps
 * typing otherwise.
 *
 * Catch-up when stored equals the draft is the attorney's own save landing:
 * without it the field stops following the set after the first edit, and the
 * unmount flush writes the old words back.
 */
export function useAdoptedDraft(
  stored: string,
): [string, (next: string) => void] {
  const [draft, setDraft] = useState(stored);
  const adoptedRef = useRef(stored);

  if (stored === draft) {
    adoptedRef.current = stored;
  } else if (stored !== adoptedRef.current && draft === adoptedRef.current) {
    adoptedRef.current = stored;
    setDraft(stored);
  }

  return [draft, setDraft];
}
